import React from "react";
import CareersRegister from "../../registration"

const OtpVerifyScreen = (props) => {
    return (
        // First/main screen
        <div className="careers_register_main">
            <>
                <CareersRegister
                    screen="otp_verify"
                />
            </>
        </div >
    );
};


export default OtpVerifyScreen;